export function downloadBlob(data, filename) {
  const fileUrl = window.URL.createObjectURL(new Blob([data]));
  const fileLink = document.createElement("a");

  fileLink.href = fileUrl;
  fileLink.setAttribute("download", filename);
  document.body.appendChild(fileLink);
  fileLink.click();

  setTimeout(() => {
    document.body.removeChild(fileLink);
    window.URL.revokeObjectURL(fileUrl);
  });
}
